import { useQuery } from 'hooks/useCustomQuery';
import getWholesaler from '@/API/Wholesaler/getWholesaler';

const useGetWholesalerByID = (
    wholesalerId,
    onSuccess,
    resetToMainTable,
    enabled,
) => {
    return useQuery({
        queryKey: ['wholesaler', wholesalerId],
        queryFn: () => getWholesaler(wholesalerId),
        enabled: enabled && Boolean(wholesalerId),
        onSuccess: (data) => {
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Error fetching wholesaler:', error);
            if (resetToMainTable) {
                resetToMainTable();
            }
        },
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
    });
};

export default useGetWholesalerByID;
